import { PhatoAccessContext } from '../../hooks/auth';

export interface PhatoLoginData {
  login: string;
  password: string;
  isMedico: boolean;
}

export function createPhatoAccessContext({
  login,
  password,
  isMedico,
}: PhatoLoginData): PhatoAccessContext {
  const normalizedLogin = login.replace(/\D/g, '');
  const normalizedPassword = password.replace(/\D/g, '');

  return {
    isMedico,
    crm: isMedico ? normalizedLogin : '',
    cpf: isMedico ? normalizedPassword : normalizedLogin,
    dataNascimento: isMedico ? '' : password,
  };
}

export function createPhatoBusinessAccessContext(
  cnpj: string,
): PhatoAccessContext {
  return {
    isMedico: false,
    isBusiness: true,
    crm: '',
    cpf: '',
    cnpj: cnpj.replace(/\D/g, ''),
    dataNascimento: '',
  };
}
